import { render, staticRenderFns } from "./importMusicDetail.vue?vue&type=template&id=69180991&scoped=true"
import script from "./importMusicDetail.vue?vue&type=script&lang=js"
export * from "./importMusicDetail.vue?vue&type=script&lang=js"
import style0 from "./importMusicDetail.vue?vue&type=style&index=0&id=69180991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69180991",
  null
  
)

export default component.exports